import React from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { PrimaryButton } from "./Buttons";
import { Button } from "@material-tailwind/react";
import { useUser } from "../context/UserContext";


const CustomCollapseCard = ({
  title,
  children,
  isOpen,
  toggle,
  onClick,
  uploading,
  showChevron = true,
  contentWithEdit,
  showSaveAction, 
  additionalButtons, 
}) => {
  const {isReadOnly} = useUser();
  const handleSave = async () => {
    await onClick(); 
    toggle(); 
  };

  return (
    <div className="border rounded-lg bg-white p-2 lg:p-4">
      {/* Header Section */}
      <div
        className="flex justify-between items-center mb-2 p-3 cursor-pointer"
        onClick={toggle}
      >
        <h1 className="lg:text-xl font-bold text-base">{title}</h1>
        <div className="flex items-center space-x-2">
          {/* Additional Buttons - BEFORE Chevron */}
          {isOpen && additionalButtons}


          {showChevron && (
            <Button
              size="sm"
              variant="outline"
              color="black"
              className="p-2 ml-2" // Keep ml-2 for space
              disabled={isReadOnly}
            >
              {isOpen ? <ChevronUp /> : <ChevronDown />}
            </Button>
          )}
        </div>
      </div>

      {isOpen && (
        <>
          {children}
          <div className="mb-2">{contentWithEdit}</div>

          {/* Save Button at the Bottom */}
          {showSaveAction && (
            <div className="flex justify-end">
              <PrimaryButton className="w-30" onClick={handleSave}>
                {uploading ? "Saving..." : "Save"}
              </PrimaryButton>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default CustomCollapseCard;